import type { IconData } from '@stacksjs/iconify-core'

export const bw4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#00cbff\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" d=\"M0 160h640v160H0z\"/><path fill=\"#000001\" d=\"M0 186h640v108H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default bw4x3
